import { ITypeDefinition } from './TypeDefinitionFactory';
import { validate } from 'email-validator';

export default class EmailDefinition implements ITypeDefinition {
  formatToLocale(value: string) {
    return value;
  }

  parseToXmlValue(value: string) {
    return value;
  }

  isValid(value: string) {
    return value === '' || validate(value);
  }
}
